import { BACKEND_DATE_FORMAT } from 'config/Vars'
import moment from 'moment'

import { stringToDate } from 'modules/core/lib/dates'

export const getFirstPaymentDate = (effectiveDate: string | undefined): string => {
  const localeEffective = effectiveDate ? stringToDate(effectiveDate, 'ui') : moment()
  const isFirstDayOfMonth = localeEffective.date() === 1

  const targetDate = isFirstDayOfMonth ? localeEffective : localeEffective.add(1, 'month')
  return targetDate.startOf('month').format(BACKEND_DATE_FORMAT)
}
